import { Injectable } from '@angular/core';
import { buttonsFirst, buttons, buttonsLast } from '../botones';

@Injectable({ providedIn: 'root' })
export class StepsContactos {
  constructor() {
    this.crear();
  }

  crear() {
    return [
      {
        attachTo: {
          element: '.step_100',
          on: 'bottom' as const,
        },
        title: 'CONTACTOS',
        text: `
                    En esta página puede administrar los contactos.  <b>No es necesario almacenar un contacto</b> para poder enviarle un documento.
                    Sólo si envía documentos repetitivamente a los mismos contactos le será de utilidad tenerlos almacenados aquí para elegirlos en el momento del  envío.
                `,
        buttons: buttonsFirst,
      },
      {
        attachTo: {
          element: '.step_200',
          on: 'bottom' as const,
        },
        title: 'NUEVO CONTACTO',
        text: `
                    Si quiere crear un nuevo contacto utilice este botón.
                `,
        buttons: buttonsFirst,
      },
      {
        attachTo: {
          element: '.step_300',
          on: 'bottom' as const,
        },
        title: 'MENÚ DE ACCIONES',
        text: `
                    Desde el menú <b>⋮</b> puede <b>exportar</b> los registros en formato CSV (compatible con Excel, Google Sheets, LibreOffice...) y <b>limpiar los filtros</b> activos de la tabla.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_500',
          on: 'bottom' as const,
        },
        title: 'COLUMNAS',
        text: `
                    Al pulsar sobre cada columna se ordenarán los registros de forma ascendente o descendente.  También puede reordenar las columnas arrastrándolas a la posición deseada manteniendo pulsado el botón del ratón.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_600',
          on: 'bottom' as const,
        },
        title: 'FILTROS',
        text: `
                    Puede filtrar los registros por columnas introduciendo valores en estas casillas.
                `,
        buttons: buttons,
      },

      {
        attachTo: {
          element: '.p-datatable-tbody',
          on: 'bottom' as const,
        },
        title: 'DATOS',
        text: `
                    En la parte central de la tabla tendrá acceso a los registros.  En la última columna se muestran las acciones que puede realizar sobre cada registro.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.p-paginator',
          on: 'bottom' as const,
        },
        title: 'PAGINADOR',
        text: `
                    Puede cambiar de página utilizando el paginador y el número de registros mostrados en cada página.
                `,
        buttons: buttonsLast,
      },
    ];
  }
}
